module.exports = __webpack_public_path__ + "5a458cf2cce9b57b1fdd8bc3d24f76cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/komikatitle/KomikaTitle-Axis-webfont.svg
// module id = 224
// module chunks = 0